import React from 'react';

import { ReactComponent as EditSvg } from '@pkg/components/Sections/Profile/icons/edit.svg';

import { EditIconWrapper } from './styles';

export const EditIcon = () => {
    return (
        <EditIconWrapper>
            <EditSvg aria-hidden />
        </EditIconWrapper>
    );
};
